<template>
    <div class="h-layout h-layout-full-height h-layout-blank">
        <div class="h-layout-content">
            <nav class="navbar navbar-expand fixed-top">
                <navbar-logo />
            </nav>

            <main class="h-o-main-content">
                <div class="container-lg">
                    <router-view />
                </div>
            </main>
        </div>

        <global-alert disable-notification />
    </div>
</template>

<script>
    import NavbarLogo from "@/components/atoms/NavbarLogo.vue";
    import GlobalAlert from '@/components/molecules/GlobalAlert'

    export default {
        components: {
            NavbarLogo,
            GlobalAlert,
        }
    }
</script>

<style lang="stylus">
    .h-layout-blank {
        background-color: #F8F8F8

        .h-layout-content {
            padding-top: calc(1rem + 50px)
        }

        .navbar {
            box-shadow 0 1px 6px rgba(black, .2)
            background-color white

            @media (min-width 992px) {
                padding-left 3rem
                padding-right 3rem !important // !important usado devido ao padding inserido pelo modal
            }
        }
    }
</style>